import { OrganizationSelectors } from '@core/organization';
import { createSelector } from 'reselect';
import _ from 'underscore';
import { PrivilegesListSelector } from '../../privileges/selectors/PrivilegesListSelectors.js';
import { UserPrivilegesValidator } from '../utils/UserPrivilegesValidator.js';
var getPrivilegesValidator = createSelector(PrivilegesListSelector.getUserPrivilegesList, OrganizationSelectors.getOrganization, function(userPrivileges) {
    return new UserPrivilegesValidator(userPrivileges);
});
var getUser = function getUser(state) {
    return state.user;
};
var getUserFirstName = createSelector(getUser, function(user) {
    return user === null || user === void 0 ? void 0 : user.firstName;
});
var getUserLastName = createSelector(getUser, function(user) {
    return user === null || user === void 0 ? void 0 : user.lastName;
});
var getUserEmail = createSelector(getUser, function(user) {
    return user === null || user === void 0 ? void 0 : user.email;
});
var getUsername = createSelector(getUser, function(user) {
    var _ref;
    return (_ref = user === null || user === void 0 ? void 0 : user.username) !== null && _ref !== void 0 ? _ref : '';
});
var getUserDisplayName = createSelector(getUser, getUsername, function(user, username) {
    var _ref, _ref1;
    return (_ref = (_ref1 = user === null || user === void 0 ? void 0 : user.displayName) !== null && _ref1 !== void 0 ? _ref1 : user === null || user === void 0 ? void 0 : user.name) !== null && _ref !== void 0 ? _ref : username;
});
var getUserRealms = createSelector(getUser, function(user) {
    var _ref;
    return _.chain((_ref = user === null || user === void 0 ? void 0 : user.realms) !== null && _ref !== void 0 ? _ref : []).filter({
        member: true
    }).map('realm').value();
});
var isRelevanceInspectorAvailable = createSelector(getPrivilegesValidator, function(validator) {
    return validator.canExecuteQuery && validator.canReplayAnyQuery;
});
var getAdditionalInformation = createSelector(getUser, function(user) {
    var _ref;
    return (_ref = user === null || user === void 0 ? void 0 : user.additionalInformation) !== null && _ref !== void 0 ? _ref : {};
});
var canViewAllContent = createSelector(getPrivilegesValidator, function(user) {
    return user.canViewAllContent;
});
export var UserSelectors = {
    getPrivilegesValidator: getPrivilegesValidator,
    getUser: getUser,
    getUsername: getUsername,
    getUserDisplayName: getUserDisplayName,
    getUserRealms: getUserRealms,
    getAdditionalInformation: getAdditionalInformation,
    getUserFirstName: getUserFirstName,
    getUserLastName: getUserLastName,
    getUserEmail: getUserEmail,
    isRelevanceInspectorAvailable: isRelevanceInspectorAvailable,
    canViewAllContent: canViewAllContent
};

//# sourceMappingURL=UserSelectors.js.map